const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    minHeight: 600,
    minWidth: 600,
    maxWidth: minWidth / 1.5
  },
  form: {
    height: 430,
    overflowY: 'auto'
  },
  flex: {
    flex: 1
  },
  scrollableList: {
    maxHeight: 140,
    overflow: 'auto'
  },
  summary: {
    padding: theme.spacing.unit
  },
  error: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#D42E4C',
    padding:10,
    textAlign: 'center',
    '& h3': {
      color:'white',
      fontSize: 18,
    },
    '& p':{
      color:'white',
    }
  },
  warning: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff8e1',
    border: '1px solid #f5c542',
    boxSizing: 'border-box',
    width: 520,
    maxWidth: '100%',
    padding: 10,
    marginBottom: theme.spacing.unit * 2,
    '& p': {
      color: '#5f4b00',
      margin: 0,
      lineHeight: 1.4,
      overflowWrap: 'break-word'
    }
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    minWidth:40,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing.unit,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  submitProgress: {
    color: 'white'
  },
  close: {
    padding:0,
    minWidth:40,
  },
})

export default styles
